// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";

type HandlerType = ApiHandler<any & UpdateSearchFieldsType>;

export const DispatchUpdateSearchFieldsParameter: HandlerType = props => {
    props.dispatch({
        type: "xReorderPad/UpdateSearchParams",
        parameter: props.parameter,
    } as any);
};

export const chain = [DispatchUpdateSearchFieldsParameter];

const updateReorderPadSearchFields = createHandlerChainRunner(chain, "UpdateReorderPadSearchFields");
export default updateReorderPadSearchFields;
